<template>
  
  <div>

    <div class="ui large breadcrumb">      
      <back-button-link label="Laudos" to="/procs/certs" />
      <i class="right chevron icon divider"></i>
      <div class="section">
        <strong>Visualizar Laudo</strong>
      </div>      
    </div>

    <div class="ui divider"></div>

    <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>    

    <div v-else class="animated fadeIn">

      <action-buttons :cert="cert" @onActionPerformed="loadCert()" />

      <horizontal-tabs class="m-t-10 m-b-15" ref="horizontalTabs" :tabs="tabs" @onSelectTab="onSelectTab" />

      <overview-tab v-if="activeTab == 'overview'" :cert="cert" @onRemoveComplement="loadCert()" />
      <diagnosis-tab v-if="activeTab == 'diagnosis'" :cert="cert" />
      <images-tab v-if="activeTab == 'images'" :cert="cert" />
      <attachments-tab v-if="activeTab == 'attachments'" :cert="cert" @onSaveComments="onSaveAttachmentComments" />
      <financial-tab v-if="activeTab == 'financial'" :cert="cert" />      
      <historic-tab v-if="activeTab == 'historic'" :cert="cert" />            

    </div>    

  </div>

</template>  

<script>

  import CertService from "@/services/cert-service"
  import { BackButtonLink, HorizontalTabs } from "@/components"
  import { ActionButtons, OverviewTab, DiagnosisTab, FinancialTab, ImagesTab, AttachmentsTab, HistoricTab } from "./index"  

  export default {

    name: "ShowCertPage",
    
    data() {
      return {
        loading: true,
        cert: {},
        service: new CertService(),
        activeTab: "overview",
        tabs: [],     
      }
    },

    components: {
      BackButtonLink,
      ActionButtons,
      HorizontalTabs,
      OverviewTab,
      DiagnosisTab,
      FinancialTab,
      ImagesTab,
      AttachmentsTab,
      HistoricTab,
    },

    created() {
      this.loadCert()
    },    

    methods: {            

      async loadCert() {

        this.loading = true

        try {

          this.cert = await this.service.findById(this.$route.params.id)

          this.createTabs()
          this.checkUserProfile()
          
          this.activeTab = "overview"          

        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.loading = false
        }
      },

      createTabs() {

        this.tabs = []

        this.tabs.push({ id: "overview", label: "Visão Geral" })

        if (this.$isSimavet())
          this.tabs.push({ id: "diagnosis", label: "Diagnóstico" })

        if (this.$isSimavet() || this.cert.status == "finished")
          this.tabs.push({ id: "images", label: "Imagens" })

        if (this.$isSimavet())
          this.tabs.push({ id: "attachments", label: "Anexos" })
        
        if (this.$isAdmin() || this.$isFinancial())
          this.tabs.push({ id: "financial", label: "Financeiro" })

        if (this.$isSimavet())
          this.tabs.push({ id: "historic", label: "Histórico" })      
      },

      checkUserProfile() {

        let allowed = true

        if (!this.$isSimavet() && this.cert.status !== "finished")
          this.cert.status = "maintenance"

        if (
            (this.$isCustomer() && !this.isCustomerCert()) ||
            (this.$isVet() && !this.isVetCert())
          ) {
          allowed = false
        }

        if (!allowed)
          this.$router.push("/not-found")    
      },

      isCustomerCert() {
        
        let customerIds = []

        this.$store.state.auth.user.customers.forEach((customer) => customerIds.push(customer.id))

        return (customerIds.indexOf(this.cert.customerId) > -1)
      },

      isVetCert() {

        let vetId = null
        let customerIds = []

        if (this.$store.state.auth.user.vet)
          vetId = this.$store.state.auth.user.vet.id

        this.$store.state.auth.user.customers.forEach((customer) => customerIds.push(customer.id))

        return (this.cert.vetId == vetId || (customerIds.indexOf(this.cert.customerId) > -1))
      },      

      onSelectTab(id) {
        this.activeTab = id
      },

      onSaveAttachmentComments(comments) {
        this.cert.attachmentComments = comments
      }
    },
  }

</script>